import './StoreBilling.css';
import React, { Suspense } from 'react';
import { SubscriptionCardSkeleton, PlansGridSkeleton, BillingTableSkeleton } from '../../billing/components/BillingSkeletons';
import { billingStrings } from '../../billing/billing.strings';
import BillingErrorBoundary from '../../billing/BillingErrorBoundary';
import PageHeader from '../../../../shared/components/layout/PageHeader';

const StoreBillingPage = React.lazy(() => import('../../billing/StoreBillingPage'));

const Fallback = () => (
  <section className="section store-billing-shell">
    <PageHeader
      title={billingStrings.loadingTitle}
      description={billingStrings.loadingSubtitle}
    />
    <SubscriptionCardSkeleton />
    <div className="card billing-plans">
      <div className="billing-plans-header">
        <h3>{billingStrings.choosePlanTitle}</h3>
      </div>
      <PlansGridSkeleton />
    </div>
    <div className="card billing-history-card">
      <h3>{billingStrings.billingHistoryTitle}</h3>
      <BillingTableSkeleton />
    </div>
  </section>
);

const StoreBilling = () => (
  <BillingErrorBoundary>
    <Suspense fallback={<Fallback />}>
      <StoreBillingPage />
    </Suspense>
  </BillingErrorBoundary>
);

export default StoreBilling;
